import { render, staticRenderFns } from "./FilesUploadModal.vue?vue&type=template&id=0b617b90&"
import script from "./FilesUploadModal.vue?vue&type=script&lang=js&"
export * from "./FilesUploadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports